import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=359dbb72"
import script from "./invoice.vue?vue&type=script&lang=js"
export * from "./invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BannerTop: require('D:/private/personal-finance/src/components/Common/BannerTop.vue').default,Header: require('D:/private/personal-finance/src/components/Common/Header.vue').default,GoTop: require('D:/private/personal-finance/src/components/Common/GoTop.vue').default})
